import React from "react";
import classnames from "classnames";
import YearSelect from "Utils/YearSelect";

const StandardYearSelect = props => {
  const {
    input,
    className,
    meta: { touched, error },
    ...others
  } = props;

  return (
    <YearSelect
      {...input}
      {...others}
      className={classnames({
        [className]: className,
        error: touched && error
      })}
    />
  );
};

export default StandardYearSelect;
